import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'
import { ClientChecksStep } from '../../../constants/enums'

export interface Requirement {
  displayAgreements?: boolean
  displayIdentityCheck?: boolean
  displayIncomeCheck?: boolean
  displayPaymentCheck?: boolean
  displayPollingWarning?: boolean
  nextUrl?: ClientChecksStep
}

export type RequirementState = ImmutableGenericType<Requirement>

export const initialState: RequirementState = Immutable({
  displayAgreements: undefined,
  displayIdentityCheck: undefined,
  displayIncomeCheck: undefined,
  displayPaymentCheck: undefined,
  displayPollingWarning: undefined,
  nextUrl: undefined,
})
